export default () => {
    const carouselContainers = document.querySelectorAll('*[carousel-component]');
    if (carouselContainers.length === 0)
        return;
    import(/* webpackChunkName: "carousel" */ "../classes/carouselClass")
        .then(({ default: Carousel }) => {
        carouselContainers.forEach(carouselContainer => {
            new Carousel(carouselContainer);
        });
    })
        .catch(() => "An error with carousel component occurred");
};
